import PhoneInput from './PhoneInput'

export default PhoneInput



// WEBPACK FOOTER //
// ./src/app/elements/PhoneInput/index.js